import type { FormEventHandler, JSX, ReactNode } from 'react';
import { Stack } from '@mui/material';
import { tss } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import { Text } from '../Text';
import { Button } from '../Button';

// -------------------------------------- //
// EditInfoLayout //
// -------------------------------------- //
type EditInfoLayoutProps = {
    title: ReactNode;
    onSubmit: FormEventHandler<HTMLFormElement>;
    isFormDisabled?: boolean;
} & Omit<JSX.IntrinsicElements['form'], 'title'>;

export function EditInfoFormLayout({
    children,
    className,
    title,
    onSubmit,
    isFormDisabled,
    ...rootProps
}: EditInfoLayoutProps) {
    const { classes, cx } = useEditInfoFormLayoutStyles();

    return (
        <form
            {...rootProps}
            className={cx(classes.drawer, className)}
            autoComplete="off"
            noValidate
            onSubmit={onSubmit}
        >
            <Stack spacing={4}>
                <Text color="gray" textTransform="uppercase" fontWeight="600">
                    {title}
                </Text>
                <Stack spacing={2}>{children}</Stack>
                <div>
                    <Button fullWidth disabled={isFormDisabled} type="submit">
                        <FormattedMessage defaultMessage="Save" />
                    </Button>
                </div>
            </Stack>
        </form>
    );
}

const useEditInfoFormLayoutStyles = tss.create({
    drawer: {
        padding: '0 24px',
    },
});

export default EditInfoFormLayout;
